
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomumbaiairporttaxi() {



    const cardData =
    {
        keyword: 'Pune To Mumbai Airport Taxi',
        heading: 'Mauli Cabs:  Pune To Mumbai Airport Taxi',
        headingDescription: 'Mauli Cabs provides dependable Pune to Mumbai Airport taxi services, ensuring you reach your destination on time and with complete comfort. Whether you are traveling for business, leisure, or catching an important flight, we offer a wide range of vehicles including sedans, SUVs, and premium cars. Enjoy a hassle-free journey with professional drivers, transparent pricing, no hidden charges, and a commitment to punctuality and customer satisfaction.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is Mumbai’s most iconic landmark, built during the British Raj. Overlooking the Arabian Sea, it’s a popular spot for tourists to admire the architecture and enjoy ferry rides."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the 'Queen’s Necklace' because of its sparkling streetlights at night, Marine Drive is a beautiful 3-km long promenade along the coast, perfect for evening walks and enjoying sunsets."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is an architectural marvel that blends Victorian Gothic and Indian styles. It's a bustling railway station and a symbol of Mumbai’s heritage."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these rock-cut caves are known for their stunning sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and a fascinating excursion from Mumbai."
    },
    {
        "title": "Juhu Beach",
        "description": "One of Mumbai’s most famous beaches, Juhu Beach is known for its lively atmosphere, street food stalls, and beautiful sunsets. It’s a favorite hangout for both locals and tourists."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a bustling shopping street filled with vibrant shops, cafes, and street vendors. It’s a great place to pick up souvenirs, enjoy local snacks, and experience Mumbai’s street culture."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Situated on an islet off the coast, Haji Ali Dargah is a beautiful mosque and tomb visited by people of all faiths. Its stunning location amidst the sea makes it a peaceful and spiritual site."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Sanjay Gandhi National Park is a green oasis in the bustling city, offering nature trails, a mini-zoo, and the famous Kanheri Caves. It’s perfect for trekking, cycling, and family outings."
    },
    {
        "title": "Chor Bazaar",
        "description": "Chor Bazaar, or the 'Thieves Market,' is one of Mumbai’s oldest markets, famous for antiques, vintage items, and rare finds. It’s a paradise for bargain hunters and collectors."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane bridge connecting Bandra and Worli. Driving across offers stunning views of the Mumbai skyline and the Arabian Sea."
    }
],

"services": [
    {
        "name": "Pune to Mumbai Airport Taxi Service",
        "description": "Mauli Cabs offers dependable taxi services from Pune to Mumbai Airport. Enjoy a smooth and timely ride with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Book Pune to Mumbai Airport Taxi",
        "description": "Book your taxi from Pune to Mumbai Airport easily with Mauli Cabs. We provide prompt and comfortable service for all your airport travel needs."
    },
    {
        "name": "Affordable Pune to Mumbai Airport Transportation",
        "description": "Looking for affordable transport to Mumbai Airport from Pune? Mauli Cabs offers budget-friendly taxi services without compromising comfort or reliability."
    },
    {
        "name": "Private Taxi for Mumbai Airport from Pune",
        "description": "Travel privately from Pune to Mumbai Airport with Mauli Cabs. Our dedicated cabs ensure privacy, comfort, and on-time arrival for your flight."
    },
    {
        "name": "Mumbai Airport Pick-Up and Drop-Off from Pune",
        "description": "Mauli Cabs offers reliable pick-up and drop-off services to and from Mumbai Airport. Travel stress-free with our timely and professional service."
    },
    {
        "name": "Pune to Mumbai Airport Shuttle",
        "description": "Choose Mauli Cabs' shared or exclusive shuttle services from Pune to Mumbai Airport. A cost-effective and convenient option for frequent travelers."
    },
    {
        "name": "Luxury Taxi for Mumbai Airport Transfer from Pune",
        "description": "Travel in style to Mumbai Airport from Pune with Mauli Cabs' luxury taxi options. Experience comfort, elegance, and timely service every step of the way."
    },
    {
        "name": "Comfortable Taxi Ride to Mumbai Airport from Pune",
        "description": "Mauli Cabs provides a comfortable and stress-free taxi ride from Pune to Mumbai Airport. Our vehicles are spacious and ideal for long-distance travel."
    },
    {
        "name": "Mumbai Airport Cab Booking",
        "description": "Easily book a cab to Mumbai Airport from Pune with Mauli Cabs. Our simple booking process and reliable service ensure a worry-free airport transfer."
    },
    {
        "name": "Professional Airport Transfer from Pune to Mumbai",
        "description": "Mauli Cabs offers professional airport transfer services from Pune to Mumbai. Our experienced drivers ensure punctuality and comfort throughout your journey."
    }
],

"tableData": [
    ["Pune to Mumbai Airport Taxi Service", "Book Pune to Mumbai Airport Taxi"],
    ["Affordable Pune to Mumbai Airport Transportation", "Private Taxi for Mumbai Airport from Pune"],
    ["Mumbai Airport Pick-Up and Drop-Off from Pune", "Pune to Mumbai Airport Shuttle"],
    ["Luxury Taxi for Mumbai Airport Transfer from Pune", "Comfortable Taxi Ride to Mumbai Airport from Pune"],
    ["Mumbai Airport Cab Booking", "Professional Airport Transfer from Pune to Mumbai"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we understand the importance of reaching the airport on time. For your Pune to Mumbai Airport Taxi, our drivers ensure prompt pickups and timely arrivals, so you never have to worry about missing your flight."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of vehicles for your Pune to Mumbai Airport Taxi, including sedans, SUVs, and premium cars. Each vehicle is equipped with air conditioning, spacious interiors, and ample legroom, ensuring a comfortable ride to and from the airport."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are professional, experienced, and familiar with the best routes to Mumbai Airport from Pune. They prioritize your safety, comfort, and punctuality, ensuring you have a smooth and efficient ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Mumbai Airport Taxi, with no hidden charges. We provide transparent pricing so you can enjoy a stress-free journey without worrying about unexpected fees."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are well-maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and comfortable ride to Mumbai Airport."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether it's a midnight flight or an early morning departure, Mauli Cabs is available 24/7 for your Pune to Mumbai Airport Taxi. You can rely on our customer service team to assist you with your booking at any time of day or night."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Mumbai Airport Taxi with Mauli Cabs is quick and easy. You can reserve your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Mumbai Airport Taxi. Whether you have specific time preferences or need a specialized service, let us know, and we’ll tailor the journey to meet your needs."
    }
]







    }



    const faqData = [
        {
            question: 'How do I book a taxi from Pune to Mumbai Airport with Mauli Cabs?',
            answer: 'Booking your taxi is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Mumbai Airport as your destination, then choose the vehicle that fits your needs. Alternatively, you can contact our support team for assistance.',
        },
        {
            question: 'What types of taxis are available for Pune to Mumbai Airport?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options. Choose the one that best suits your comfort and space requirements for the journey.',
        },
        {
            question: 'Is the fare from Pune to Mumbai Airport fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. There are no hidden costs, and you will know the total fare upfront.',
        },
        {
            question: 'Can I book a round trip from Pune to Mumbai Airport?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we will take care of the rest.',
        },
        {
            question: 'How long does the journey from Pune to Mumbai Airport take?',
            answer: 'The ride from Pune to Mumbai Airport typically takes around 3 to 3.5 hours, depending on traffic and road conditions. We strive to ensure a smooth and timely journey, allowing you to catch your flight with ease.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Mumbai Airport route?',
            answer: 'Yes, our drivers are well-trained, experienced, and familiar with the best routes to ensure a safe, efficient, and comfortable ride to Mumbai Airport.',
        },
        {
            question: 'Can I book a taxi for early morning or late-night trips to Mumbai Airport?',
            answer: 'Yes, Mauli Cabs is available for early morning and late-night trips. We understand the importance of reaching the airport on time, no matter the hour.',
        },
        {
            question: 'Are the taxis air-conditioned and well-maintained?',
            answer: 'Absolutely! All our taxis are air-conditioned, well-maintained, and thoroughly cleaned for a comfortable and hygienic journey.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy available through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Mumbai Airport trip?',
            answer: 'Mauli Cabs offers competitive pricing, a wide range of vehicle options, professional drivers, and punctual service. Whether it’s for business or leisure, we ensure a stress-free and comfortable journey to Mumbai Airport.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Patel",
            position: "Business Traveler",
            text: "I have used Mauli Cabs multiple times for my trips to Mumbai Airport. The drivers are always on time, and the ride is comfortable and smooth. Highly recommend them for stress-free airport travel!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Verma",
            position: "Frequent Flyer",
            text: "Mauli Cabs made my trip to Mumbai Airport seamless. The driver was courteous, the vehicle was clean, and I reached the airport on time without any hassle. Excellent service!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Airport Taxi by Mauli Cabs",
        "description": "Mauli Cabs offers professional and affordable taxi service from Pune to Mumbai Airport. Book private or luxury airport transfers with pick-up and drop-off options. Enjoy a comfortable, on-time ride with 24x7 online booking.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "7800"
        }
      };
      
     
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Mumbai Airport Taxi | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Mumbai airport taxi with Mauli Cabs. Affordable, comfortable, and reliable airport transfers with private and luxury options. 24x7 pick-up and drop-off service available."
        />
        <meta
          name="keywords"
          content="Pune to Mumbai airport taxi service, Book Pune to Mumbai airport taxi, Affordable Pune to Mumbai airport transportation, Private taxi for Mumbai airport from Pune, Mumbai airport pick-up and drop-off from Pune, Pune to Mumbai airport shuttle, Luxury taxi for Mumbai airport transfer from Pune, Comfortable taxi ride to Mumbai airport from Pune, Mumbai airport cab booking, Professional airport transfer from Pune to Mumbai"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiairporttaxi;